'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/state/get-client-rect.js
// module id = 131
// module chunks = 0